import {
    postProviderLoading,
    postProviderRequest,
    postProviderSuccess,
    postProviderReject,
    postProviderReset
} from "../../actions/provider/post";

export const postProvider = (formData) => async (dispatch, getState) => {
    dispatch(postProviderLoading());
    try {
        const { data } = await postProviderRequest(formData, getState);
        dispatch(postProviderSuccess(data))
    } catch (error) {
        dispatch(postProviderReject(error))
    } finally {
        setTimeout(() => { dispatch(postProviderReset()) }, 3000);
    }
    return Promise.resolve();
};